import { BotRegular, CircleRegular, DatabaseWindowRegular, DocumentPercentRegular } from '@fluentui/react-icons';
import { CalculationReviewRegular } from './custom-icons/CalculationReview';

// this is going to need fleshed out for what icon to render and how, whether filled or not
// depending on what item is selected, etc. from collateral. we'll iterate.  =)
// i don't like having to specify the font size here but it's TINY otherwise
// if we have very many custom icons, we're likely going to need some way to style them. TBD.
const LinkIcon = ({ iconName }: { iconName: string | null | undefined }) => {
    const fontSize = '24px';

    switch (iconName) {
        case 'DatabaseWindow':
            return <DatabaseWindowRegular fontSize={fontSize} />;
        case 'Bot':
            return <BotRegular fontSize={fontSize} />;
        case 'DocumentPercent':
            return <DocumentPercentRegular fontSize={fontSize} />;
        case 'CalculationReview':
            return <CalculationReviewRegular width={25} height={25} />;

        default:
            return <CircleRegular fontSize={fontSize} />;
    }
};

export default LinkIcon;
